<template>
    <div class="activityEdit form" v-show="pageshow">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="135px" class="demo-ruleForm">
            <div class="activityMsgBox">
                <div class="title"><p>内容设置</p></div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="模板选择" class="reduceMg">
                            <el-radio-group :disabled="isBegin" v-model="ruleForm.templatetype" @change="templatetypeChange">
                                <el-radio :label="1">活动模板</el-radio>
                                <el-radio :label="2">文章模板</el-radio>
                            </el-radio-group>
                            <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                <div class="tipsP">
                                    <p>活动模板：直接展示活动详情页</p>
                                    <p>文章模板：优先展示文章内容，底部通过广告贴片形式展示活动详情入口</p>
                                </div>
                                <i class="el-icon-info" slot="reference"></i>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="分销类型" class="reduceMg">
                            <el-radio-group :disabled="isBegin" v-model="ruleForm.distype" @change="distypeChange">
                                <el-radio :label="1">支付分销</el-radio>
                                <el-radio :label="2" :disabled="ruleForm.templatetype === 1">表单分销</el-radio>
                                <el-radio :label="3" :disabled="ruleForm.templatetype === 1">阅读分销</el-radio>
                            </el-radio-group>
                            <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                <div class="tipsP">
                                    <p>支付分销：分享给用户支付后，获得分销佣金</p>
                                    <p>表单分销：分享给用户填表，即可获得分销佣金</p>
                                    <p>阅读分销：分享给用户点击阅读，即可获得分销佣金“表单分销”和“阅读分销”类型需要商家提前存入奖励金额</p>
                                </div>
                                <i class="el-icon-info" slot="reference"></i>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="活动主图" v-if="ruleForm.templatetype === 1" class="cover isRequired" prop="coveratturlid">
                            <div class="imgBox">
                                <i class="el-icon-picture" v-if="!coveratturlidImg"></i>
                                <img class="activityCoverImage" :src="coveratturlidImg.furl + '?' + time" v-else-if="coveratturlidImg && coveratturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <!-- <UploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></UploadFile> -->
                                <el-button @click.native="openDialog">选择文件</el-button>
                                <p>建议尺寸750*420px的JPG、PNG格式，<br> 图片小于2M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="活动标题" v-if="ruleForm.templatetype === 1" prop="title">
                            <el-input v-model="ruleForm.title" maxlength="40" show-word-limit placeholder="输入活动标题，不超过40个字"></el-input>
                        </el-form-item>
                        <el-form-item label="文章标题" v-else prop="articletitle">
                            <el-input v-model="ruleForm.articletitle" maxlength="40" show-word-limit placeholder="请输入文章标题，不超过40个字"></el-input>
                        </el-form-item>
                        <el-form-item label="活动简介" v-if="ruleForm.templatetype === 1" prop="subtitle">
                            <el-input v-model="ruleForm.subtitle" maxlength="100" show-word-limit :placeholder="ruleForm.templatetype === 1 ? '输入活动' : '输入文章' + '简介，不超过100个字'"></el-input>
                        </el-form-item>
                        <el-form-item label="活动详情" class="haveUEditor" v-show="ruleForm.templatetype === 1">
                            <uEditor :content="ruleForm.eventdesp" ref="uEditor1" @getUEditorContent="getTrySeeContent"></uEditor>
                        </el-form-item>
                        <el-form-item label="文章详情" class="haveUEditor" v-show="ruleForm.templatetype === 2">
                            <uEditor :content="ruleForm.articledesp" ref="uEditor3" @getUEditorContent="getArticleTrySeeContent"></uEditor>
                        </el-form-item>
                    </div>
                    <div class="right">
                        <div class="topBox">
                            <img class="top" :src="require('@/common/images/toolmgt/view-top.png')" alt="">
                        </div>
                        <div class="innerBox" v-if="ruleForm.templatetype === 1">
                            <div class="coverImgBox">
                                <img class="activityCoverImage" :src="coveratturlidImg.furl + '?' + time" v-if="coveratturlidImg && coveratturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="priceBox">
                                <p class="price">￥{{ruleForm.saleprice}}</p>
                                <p class="outofprint">已售{{ruleForm.fakesalecount === '' ? 0 : ruleForm.fakesalecount}}</p>
                            </div>
                            <div class="rightTitleBox">
                                <p class="rightTitle">{{ruleForm.title === '' ? '活动标题' : ruleForm.title}}</p>
                                <p class="rightSubtitle">{{ruleForm.subtitle === '' ? '活动简介' : ruleForm.subtitle}}</p>
                            </div>
                            <div class="detailsBox">
                                <p class="detailsTitle">活动详情</p>
                                <div class="detailsContent" v-html="ruleForm.eventdesp" v-if="ruleForm.eventdesp"></div>
                            </div>
                        </div>
                        <div class="innerBox" v-if="ruleForm.templatetype === 2">
                            <div class="home">
                                <img :src="require('@/common/images/toolmgt/distribution_home.png')" alt="">
                                <div>发布方名称</div>
                            </div>
                            <!-- <div class="coverImgBox">
                                <img class="activityCoverImage" :src="coveratturlidImg.furl + '?' + time" v-if="coveratturlidImg && coveratturlidImg.furl + '?' + time" alt="">
                            </div> -->
                            <div class="rightTitleBox">
                                <p class="rightTitle">{{ruleForm.articletitle === '' ? '文章标题' : ruleForm.articletitle}}</p>
                                <!-- <p class="rightSubtitle">{{ruleForm.articledesp === '' ? '文章内容' : ruleForm.articledesp}}</p> -->
                            </div>
                            <div class="nameTime">
                                <p class="name">发布方名称</p>
                                <p class="time">{{nowDate}}</p>
                            </div>
                            <div class="articleDetailsBox">
                                <!-- <p class="detailsTitle">文章详情</p> -->
                                <div class="detailsContent" v-html="ruleForm.articledesp ? ruleForm.articledesp : '文章内容'"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title paster" v-if="ruleForm.templatetype === 2"><p>贴片广告设置</p></div>
                <div class="contentBox" v-if="ruleForm.templatetype === 2">
                    <div class="left">
                        <el-form-item label="贴片链接类型">
                            <el-radio-group v-model="ruleForm.disadlinktype">
                                <el-radio :label="1" :disabled="ruleForm.distype === 2 || ruleForm.distype === 3">链接活动详情
                                </el-radio>
                                <el-radio :label="2" :disabled="ruleForm.distype === 3">直接参与活动
                                </el-radio>
                                <el-radio :label="3" :disabled="ruleForm.distype === 1 || ruleForm.distype === 2">自定义链接
                                </el-radio>
                            </el-radio-group>
                            <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                <div class="tipsP">
                                    <p>链接活动详情：链接到对应的活动详情页面，需配置活动详情信息，支付分销可选择</p>
                                    <p>直接参与活动：用户点击后直接参与活动</p>
                                    <p>自定义链接：用户点击后打开自定义的链接地址</p>
                                </div>
                                <i class="el-icon-info" slot="reference"></i>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="贴片标题" prop="disadcontent">
                            <el-input v-model="ruleForm.disadcontent" maxlength="50" show-word-limit placeholder="输入贴片内容，不超过50个字"></el-input>
                        </el-form-item>
                        <el-form-item label="贴片名称" prop="disadname">
                            <el-input v-model="ruleForm.disadname" maxlength="20" show-word-limit placeholder="输入贴片名称，不超过20个字"></el-input>
                        </el-form-item>
                        <el-form-item label="贴片类型">
                            <el-radio-group v-model="ruleForm.disadcontenttype"  @change="disadcontenttypeChange">
                                <el-radio :label="1">图片</el-radio>
                                <el-radio :label="2">视频</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="广告图片" v-if="ruleForm.disadcontenttype === 1" class="cover disad havaImg" prop="disadcontentid">
                            <div class="imgBox">
                                <i class="el-icon-picture" v-if="!disadcontentid"></i>
                                <img class="activityCoverImage" :src="disadcontentidurl + '?' + time" v-else-if="disadcontentid && disadcontentid.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <!-- <UploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></UploadFile> -->
                                <el-button @click.native="openDisadDialog">选择文件</el-button>
                                <p>建议尺寸750*420px的JPG、PNG格式，<br> 图片小于2M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="广告视频" v-if="ruleForm.disadcontenttype === 2" class="cover disad havaImg" prop="disadcontentid">
                            <div class="imgBox">
                                <i class="el-icon-video-camera-solid" v-if="!disadcontentid"></i>
                                <video class="activityCoverImage" controls="controls" :src="disadcontentidurl + '?' + time" v-else-if="disadcontentid && disadcontentid.furl + '?' + time" alt="" />
                            </div>
                            <div class="uploadFileBox">
                                <UploadFile2 :uploadType="uploadVideoType" @setFile="setDisadFile" :fileRule="videoRule"></UploadFile2>
                                <!-- <el-button @click.native="openDialog">选择文件</el-button> -->
                                <p>建议尺寸比例16:9的MP4等视频格式，<br> 视频小于10M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="活动主图" v-if="ruleForm.disadlinktype === 1" class="cover isRequired" prop="coveratturlid">
                            <div class="imgBox">
                                <i class="el-icon-picture" v-if="!coveratturlidImg"></i>
                                <img class="activityCoverImage" :src="coveratturlidImg.furl + '?' + time" v-else-if="coveratturlidImg && coveratturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <!-- <UploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></UploadFile> -->
                                <el-button @click.native="openDialog">选择文件</el-button>
                                <p>建议尺寸750*420px的JPG、PNG格式，<br> 图片小于2M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="活动标题" v-if="ruleForm.disadlinktype === 1" prop="title">
                            <el-input v-model="ruleForm.title" maxlength="40" show-word-limit placeholder="输入活动标题，不超过40个字'"></el-input>
                        </el-form-item>
                        <el-form-item label="活动简介" v-if="ruleForm.disadlinktype === 1" prop="subtitle">
                            <el-input v-model="ruleForm.subtitle" maxlength="100" show-word-limit placeholder="输入活动简介，不超过100个字'"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="贴片详情" prop="eventdesp">
                            <uEditor :content="ruleForm.eventdesp" ref="uEditor1" @getUEditorContent="getTrySeeContent"></uEditor>
                        </el-form-item> -->
                        <el-form-item label="自定义链接" :class="{'isRequired': ruleForm.disadlinktype === 3}"  prop="disadLink" v-if="ruleForm.disadlinktype === 3">
                            <el-input v-model="ruleForm.disadcustomurl" show-word-limit placeholder="http开头，支付后直接跳转此链接"></el-input>
                        </el-form-item>
                        <el-form-item label="活动详情" class="haveUEditor" v-show="ruleForm.disadlinktype === 1">
                            <uEditor :content="ruleForm.eventdesp" ref="uEditor1" @getUEditorContent="getTrySeeContent"></uEditor>
                        </el-form-item>
                    </div>
                    <div class="rightView">
                        <div class="pasterView">
                            <div class="titleText">{{ruleForm.disadcontent ? ruleForm.disadcontent : '贴片标题'}}</div>
                            <div class="imgVideo">
                                <img v-if="ruleForm.disadcontenttype === 1" :src="disadcontentidurl ? disadcontentidurl + '?' + time : ''" alt="">
                                <video controls v-if="ruleForm.disadcontenttype === 2" :src="disadcontentidurl ? disadcontentidurl + '?' + time : ''"></video>
                            </div>
                            <div class="desp">
                                <div class="text">{{ruleForm.disadname ? ruleForm.disadname : '贴片名称'}}</div>
                                <div class="btnBox">
                                    <el-button v-if="ruleForm.disadlinktype === 2">立即参与</el-button>
                                    <el-button v-else>查看详情</el-button>
                                </div>
                            </div>
                        </div>
                        <div class="right" v-if="ruleForm.disadlinktype === 1">
                            <div class="topBox">
                                <img class="top" :src="require('@/common/images/toolmgt/view-top.png')" alt="">
                            </div>
                            <div class="innerBox">
                                <div class="coverImgBox">
                                    <img class="activityCoverImage" :src="coveratturlidImg.furl + '?' + time" v-if="coveratturlidImg && coveratturlidImg.furl + '?' + time" alt="">
                                </div>
                                <!-- <div class="priceBox">
                                    <p class="price">￥{{ruleForm.saleprice}}</p>
                                    <p class="outofprint">已售{{ruleForm.fakesalecount === '' ? 0 : ruleForm.fakesalecount}}</p>
                                </div> -->
                                <div class="rightTitleBox">
                                    <p class="rightTitle">{{ruleForm.title === '' ? '活动标题' : ruleForm.title}}</p>
                                    <p class="rightSubtitle">{{ruleForm.subtitle === '' ? '活动简介' : ruleForm.subtitle}}</p>
                                </div>
                                <div class="detailsBox">
                                    <p class="detailsTitle">活动详情</p>
                                    <div class="detailsContent" v-html="ruleForm.eventdesp" v-if="ruleForm.eventdesp"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="distributionMsgBox">
                <div class="title"><p>分销设置</p></div>
                <div class="contentBox">
                    <el-form-item label="分销时间" prop="date" class="date">
                        <el-date-picker v-model="ruleForm.begintime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="isBegin" type="datetime" placeholder="开始时间"></el-date-picker>
                        <span class="to">至</span>
                        <el-date-picker v-model="ruleForm.endtime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="结束时间"></el-date-picker>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>活动开始后不能修改开始时间，截止时间可以改</p>
                            </div>
                            <!-- <el-button slot="reference">click 激活</el-button> -->
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>

                        <!-- <el-tooltip class="item" content="" placement="right" trigger="click">
                            <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </el-form-item>
                    <el-form-item label="分销价格" prop="saleprice" class="saleprice" v-if="ruleForm.distype === 1">
                        <el-input v-model="ruleForm.saleprice" :maxlength="6" :disabled="isBegin" placeholder="请输入分销实际价格">
                            <template slot="append">元</template>
                        </el-input>
                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>本次活动的售价，用户支付时的金额</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="划线价格" prop="uprice" class="saleprice" v-if="ruleForm.distype === 1">
                        <el-input v-model="ruleForm.uprice" :maxlength="6" :disabled="isBegin" placeholder="请输入划线价格">
                            <template slot="append">元</template>
                        </el-input>
                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>相当于活动的原价，以文字中间划一横线的形式展示</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="最多参与次数">
                        <el-input v-model="ruleForm.maxbuycount" :maxlength="6" :disabled="isBegin" placeholder="同一用户最多参与次数，留空则默认为1"></el-input>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>同一个用户，在本次活动中最多能购买的次数，留空则默认为1</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="分销资格" prop="joindiscond">
                        <el-radio-group v-model="ruleForm.joindiscond" :disabled="isBegin">
                            <el-radio :label="1">无条件分销</el-radio>
                            <el-radio :label="2">参与成功才能分销</el-radio>
                        </el-radio-group>
                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>无条件分销：用户可直接获得分销资格，邀请成交后即可获得分销佣金</p>
                                <p>参与成功才能分销：用户需要自己报名参加后才有分销资格，邀请成交后获得分销佣金</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="客户绑定方式" prop="bindclienttype">
                        <el-radio-group v-model="ruleForm.bindclienttype" :disabled="isBegin">
                            <el-radio :label="2">邀请绑定（不允许抢客）</el-radio>
                            <el-radio :label="1" :disabled="ruleForm.distype===3">订单绑定（允许抢客）</el-radio>
                        </el-radio-group>
                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>邀请绑定（不允许抢客）：新用户扫码立即绑定上下级关系，绑定后不可变更</p>
                                <p>订单绑定（允许抢客）：如果没有支付，先走“邀请绑定”，支付前最后一次扫码绑定上下级关系，支付后不可变更</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="分销层级" prop="dislayer" class="distributionGrade">
                        <el-input-number v-model="ruleForm.dislayer" :disabled="isBegin" :min="1" :max="2"></el-input-number>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>2级分销不支持设置活动队长</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="收益类型" prop="dispricetype" class="earnings">
                        <el-radio-group v-model="ruleForm.dispricetype" :disabled="isBegin || ruleForm.distype === 2 || ruleForm.distype === 3">
                            <el-radio :label="1">固定收益</el-radio>
                            <el-radio :label="2">比例收益</el-radio>
                        </el-radio-group>
                        <div class="balance" v-if="ruleForm.distype === 2 || ruleForm.distype === 3">
                            当前余额<span class="balanceText">￥{{balance}}</span><el-button type="primary" @click="goRecharge">充值</el-button>
                        </div>
                    </el-form-item>
                    <!-- <el-form-item class="earnings" prop="brokerage"> -->
                    <el-form-item label="直接收益" prop="firstbrokerage">
                        <el-input v-model="ruleForm.firstbrokerage" :maxlength="6" :disabled="isBegin" @change="changeData" placeholder="请输入直接收益">
                            <template slot="append">{{ruleForm.dispricetype === 1 ? '元' : '%'}}</template>
                        </el-input>
                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>一级分销佣金，A分享给B，B购买，A拿一级分销佣金</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="间接收益" class="isRequired" v-if="ruleForm.dislayer === 2" prop="secondbrokerage">
                        <el-input v-model="ruleForm.secondbrokerage" :maxlength="6" @change="changeData" placeholder="请输入间接收益" :disabled="isBegin">
                            <template slot="append">{{ruleForm.dispricetype === 1 ? '元' : '%'}}</template>
                        </el-input>
                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>二级分销佣金，A分享给B，B分享给C，C购买，B拿一级分销佣金，A拿二级分销佣金</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="佣金提现方式" prop="cashtype">
                        <el-radio-group v-model="ruleForm.cashtype" :disabled="isBegin">
                            <el-radio :label="1">微信零钱</el-radio>
                            <el-radio :label="2">分销账户</el-radio>
                        </el-radio-group>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>微信零钱：分销佣金实时到账，直接转入用户的微信零钱，按照微信官方规定，每天上限为10笔，超出10笔后会存入分销账户</p>
                                <p>分销账户：分销佣金转入活动账户中，需要用户手动提现，支持提现到微信零钱或银行卡</p>
                            </div>
                            <!-- <el-button slot="reference">click 激活</el-button> -->
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <!-- </el-form-item> -->
                    <el-form-item label="分销订单数量" v-show="!showMore">
                        <el-input v-model="ruleForm.maxdisordercount" :maxlength="6" :disabled="isBegin" placeholder="每人最多分销多少单，超过不算佣金，留空则为不限制"></el-input>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>限制单个分销员最多可以拿多少笔佣金。超出数量的订单，不再获得佣金。一般留空为不限制。</p>
                            </div>
                            <!-- <el-button slot="reference">click 激活</el-button> -->
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="分销库存（个）" v-show="!showMore">
                        <el-input v-model="ruleForm.maxdisstockcount" :maxlength="6" :disabled="isBegin" placeholder="请输入分销库存，用完之后活动自动截止"></el-input>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>本次活动的销售数量上限，如果超出数量上限，活动会自动截止。活动发布后，可以编辑增加数量，但不可减少</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="虚拟已售数量" v-show="ruleForm.distype === 1 && !showMore">
                        <el-input v-model="ruleForm.fakesalecount" :maxlength="6" :disabled="disabled" placeholder="与实际销量累计显示，留空则默认为0"></el-input>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>本在活动详情页展示出虚拟的已售数量，活动起步阶段营造出火爆的感觉</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="是否开启活动队长" class="openColonel" v-show="!showMore">
                        <span @click.capture="clickSwitch"><el-switch v-model="ruleForm.isopeneventheader" :disabled="ruleForm.dislayer == 2"></el-switch></span>
                        <el-radio-group v-model="ruleForm.eventheaderbrokeragetype" v-if="ruleForm.isopeneventheader" :disabled="isBegin || !ruleForm.isopeneventheader">
                            <el-radio :label="1">固定收益</el-radio>
                            <el-radio :label="2" :disabled="ruleForm.distype === 2 || ruleForm.distype === 3">订单比例</el-radio>
                        </el-radio-group>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>队长可以生成带ID的专属推广活动链接，该活动链接经过传播分享后，队长ID不变，所有通过该活动链接进入的个人用户，产生的每一笔订单，队长都可以获得收益。</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item  class="date" :label="'队长收益值' + (ruleForm.eventheaderbrokeragetype === 1 ? '（元）' : '（%）')" prop="eventheaderbrokerage" v-show="ruleForm.isopeneventheader && !showMore">
                        <el-input v-model="ruleForm.eventheaderbrokerage" :maxlength="6" :disabled="isBegin" placeholder="请输入队长收益值"></el-input>
                        <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <div class="tipsP">
                                <p>该活动中，队长获得推广收益的有效期。</p>
                                <p>超出有效期后，队长不再获得该活动带来的佣金收益。若队长有效期结束时间在活动结束时间之前，以队长的有效结束时间为准。</p>
                                <p>若队长有效期结束时按在活动结束时间之后，以活动结束时间为准</p>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="队长有效期(天)" :maxlength="6" v-show="ruleForm.isopeneventheader && !showMore" class="date">
                        <el-input v-model="ruleForm.eventheaderexpiredays" :disabled="isBegin" placeholder="请输入队长有效期"></el-input>
                    </el-form-item>
                    <div class="showMore">
                        <div v-if="showMore" @click="showMoreReturn">显示更多设置 <i class="el-icon-arrow-down"></i></div>
                        <div v-if="!showMore" @click="showMoreReturn">收起更多设置 <i class="el-icon-arrow-up"></i></div>
                    </div>
                </div>
            </div>
            <div class="disFrom" v-show="ruleForm.distype === 2 || ruleForm.distype === 1">
                <div class="title"><p>分销表单<el-switch v-model="showDistributionForm"></el-switch></p></div>
                <div class="contentBox" v-show="showDistributionForm">
                    <el-form-item label="表单类型" class="optionsBox">
                        <div class="flex">
                            <div class="formOptions">
                                <div @click="addInput">
                                    <img src="../../../../common/images/nationalDistributionMenu/input.png" alt="">
                                    <div class="name">填写项</div>
                                </div>
                                <div @click="addRandio">
                                    <img src="../../../../common/images/nationalDistributionMenu/randio.png" alt="">
                                    <div class="name">单选项</div>
                                </div>
                                <div @click="addCheckbox">
                                    <img src="../../../../common/images/nationalDistributionMenu/checkbox.png" alt="">
                                    <div class="name">多选项</div>
                                </div>
                                <div @click="addSelect">
                                    <img src="../../../../common/images/nationalDistributionMenu/select.png" alt="">
                                    <div class="name">菜单项</div>
                                </div>
                            </div>
                            <div class="tips">点击相应表单类型即可新增</div>
                        </div>

                    </el-form-item>
                    <el-form-item label="表单项目" class="formItem" v-for="(item, index) in ruleForm.customformdataList" :key="index">
                        <div>
                            <div class="input" v-show="item.coltype === 1">
                                <div class="optionsName">{{index+1}}、填写项 <input type="text" v-model="item.colname" placeholder="请输入填写项内容"></div>
                                <div class="choiceBox">
                                    <el-radio-group v-model="item.isnotnull">
                                        <el-radio :label="1">必填</el-radio>
                                        <el-radio :label="0">选填</el-radio>
                                    </el-radio-group>
                                </div>
                                <img @click="deleteOptions(index)" src="../../../../common/images/nationalDistributionMenu/delete_form_item.png" alt="">
                            </div>
                            <div class="randio" v-show="item.coltype === 6">
                                <div class="optionsName">{{index+1}}、单选项 <input type="text" v-model="item.colname" placeholder="请输入单选项内容"></div>
                                <div class="choiceItem" v-for="(obj, i) in item.optionsArray" :key="i">
                                    <input type="text" placeholder="选项" v-model="obj.optionsName">
                                    <div class="delete"  @click="deleteOptionsName(index)" v-show="i === item.optionsArray.length-1">移除</div>
                                </div>
                                <div class="newOptions" @click="addOptions(index)">+新选项</div>
                                <div class="choiceBox">
                                    <el-radio-group v-model="item.isnotnull">
                                        <el-radio :label="1">必填</el-radio>
                                        <el-radio :label="0">选填</el-radio>
                                    </el-radio-group>
                                </div>
                                <img @click="deleteOptions(index)" src="../../../../common/images/nationalDistributionMenu/delete_form_item.png" alt="">
                            </div>
                            <div class="checkbox" v-show="item.coltype === 7">
                                <div class="optionsName">{{index+1}}、多选项 <input type="text" v-model="item.colname" placeholder="请输入多选项内容"></div>
                                <div class="choiceItem" v-for="(obj, i) in item.optionsArray" :key="i">
                                    <input type="text" placeholder="选项" v-model="obj.optionsName">
                                    <div class="delete"  @click="deleteOptionsName(index)" v-show="i === item.optionsArray.length-1">移除</div>
                                </div>
                                <div class="newOptions" @click="addOptions(index)">+新选项</div>
                                <div class="choiceBox">
                                    <el-radio-group v-model="item.isnotnull">
                                        <el-radio :label="1">必填</el-radio>
                                        <el-radio :label="0">选填</el-radio>
                                    </el-radio-group>
                                </div>
                                <img @click="deleteOptions(index)" src="../../../../common/images/nationalDistributionMenu/delete_form_item.png" alt="">
                            </div>
                            <div class="select" v-show="item.coltype === 8">
                                <div class="optionsName">{{index+1}}、菜单项 <input type="text" v-model="item.colname" placeholder="请输入菜单项内容"></div>
                                <div class="choiceItem"  v-for="(obj, i) in item.optionsArray" :key="i">
                                    <input type="text" placeholder="选项" v-model="obj.optionsName">
                                    <div class="delete" @click="deleteOptionsName(index)" v-show="i === item.optionsArray.length-1">移除</div>
                                </div>
                                <div class="newOptions" @click="addOptions(index)">+新选项</div>
                                <div class="choiceBox">
                                    <el-radio-group v-model="item.isnotnull">
                                        <el-radio :label="1">必填</el-radio>
                                        <el-radio :label="0">选填</el-radio>
                                    </el-radio-group>
                                </div>
                                <img @click="deleteOptions(index)" src="../../../../common/images/nationalDistributionMenu/delete_form_item.png" alt="">
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </div>
            <div class="payVoucherMsgBox">
                <div class="title">
                    <p>
                        支付凭证
                        <el-tooltip :content="showPayVouchers ? '隐藏' : '展开'" placement="top">
                            <el-switch v-model="showPayVouchers"></el-switch>
                        </el-tooltip>
                    </p>
                </div>
                <div class="contentBox" v-show="showPayVouchers">
                    <div class="left">
                        <el-form-item prop="resulttype" class="haveUEditor">
                            <el-radio-group v-model="ruleForm.resulttype">
                                <div class="noCondition">
                                    <el-radio v-model="ruleForm.resulttype" :label="1" :disabled="disabled">自定义
                                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                            <div class="tipsP">
                                                <p>自定义：</p>
                                                <p>①可以引导客户添加客服微信，在此处上传客服二维码；</p>
                                                <p>②可以引导客户关注公众号，在此处上传公众号二维码；</p>
                                                <p>③可以告知客户活动相关的活动提示，比如活动地点、活动时间、联系方式、使用说明、注意事项、兑换方式等。</p>
                                            </div>
                                            <!-- <el-button slot="reference">click 激活</el-button> -->
                                            <i class="el-icon-info" slot="reference"></i>
                                        </el-popover>
                                    </el-radio>
                                    <div class="tips" v-if="ruleForm.resulttype === 1">只显示自定义内容</div>
                                </div>
                                <div class="noCondition address">
                                    <el-radio v-model="ruleForm.resulttype" :label="5" :disabled="disabled">按地址发货
                                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                            <div class="tipsP">
                                                <p>按地址发货：</p>
                                                <p>用户下单后，在规定时间内填写收货信息，发起者根据收货信息直接寄送发货</p>
                                            </div>
                                            <!-- <el-button slot="reference">click 激活</el-button> -->
                                            <i class="el-icon-info" slot="reference"></i>
                                        </el-popover>
                                    </el-radio>
                                    <span class="tips" v-if="ruleForm.resulttype === 5">在用户参与之前需要填写收货地址</span>
                                </div>
                                <div class="buyDistribution">
                                    <el-radio v-model="ruleForm.resulttype" :label="2" :disabled="disabled">跳转链接
                                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                            <div class="tipsP">
                                                <p>跳转链接：</p>
                                                <p>通过链接跳转自有商城，完成获客。如第三方商城平台的商品/课程兑换券。客户领取后可以直接获得商品/课程</p>
                                            </div>
                                            <!-- <el-button slot="reference">click 激活</el-button> -->
                                            <i class="el-icon-info" slot="reference"></i>
                                        </el-popover>
                                    </el-radio>
                                    <el-input v-model="ruleForm.linkurl" v-if="ruleForm.resulttype === 2" maxlength="100" show-word-limit placeholder="跳转链接 不超过一百个字符" :disabled="ruleForm.resulttype !== 2"></el-input>
                                </div>
                                <div :class="{'cdkey': true, 'select': ruleForm.resulttype === 3}">
                                    <el-radio v-model="ruleForm.resulttype" :label="3" :disabled="disabled">兑换码
                                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                            <div class="tipsP">
                                                <p>兑换码：</p>
                                               <p>用户下单后，凭兑换码前往APP/小程序进行输入验证，完成获客（需要提示用户操作流程）。</p>
                                            </div>
                                            <!-- <el-button slot="reference">click 激活</el-button> -->
                                            <i class="el-icon-info" slot="reference"></i>
                                        </el-popover>
                                    </el-radio>
                                    <div class="uploadXlsBox" v-show="ruleForm.resulttype === 3">
                                        <div class="actionBox">
                                            <!-- <UploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="xlsRule"></UploadFile> -->
                                            <el-upload class="upload-demo" :disabled="$route.query.id ? true : false || ruleForm.resulttype !== 3" action="" :auto-upload="false" :on-change="handleImport" accept=".xls,.xlsx">
                                                <el-button type="success" :disabled="$route.query.id ? true : false || ruleForm.resulttype !== 3">点击上传</el-button>
                                            </el-upload>
                                            <div class="download" @click="handleDownTemplate">下载模版</div>
                                        </div>
                                        <p class="uploadXlsTips">支持XLS、XLSX格式，用户购买后自动下发</p>
                                    </div>
                                </div>
                                <div class="code">
                                    <el-radio v-model="ruleForm.resulttype" :label="4" :disabled="disabled">核销码
                                        <el-popover placement="top" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                            <div class="tipsP">
                                                <p>核销码：</p>
                                                <p>可以进行线上线下场景核销（需要引导用户截图保存）。</p>
                                            </div>
                                            <!-- <el-button slot="reference">click 激活</el-button> -->
                                            <i class="el-icon-info" slot="reference"></i>
                                        </el-popover>
                                    </el-radio>
                                    <div class="codeTips" v-if="ruleForm.resulttype === 4">核销模式成功启用，提交后请在用户列表设置核销员</div>
                                </div>
                                <!-- <div class="selfContent" v-show="ruleForm.resulttype !== 2"> -->
                                <div class="selfContent">
                                    <uEditor :disabled="disabled" :content="ruleForm.customcontent" ref="uEditor2" @getUEditorContent="getSelfContent"></uEditor>
                                    <!-- <div></div> -->
                                    <!-- <div class="content" v-html="ruleForm.customcontent" v-else></div> -->
                                </div>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="right">
                        <div class="topBox">
                            <img class="top" :src="require('@/common/images/toolmgt/view-top.png')" alt="">
                            <div class="tips">购买成功</div>
                        </div>
                        <div class="tipsContentBox">
                            <div class="innerBox">
                                <img v-if="ruleForm.resulttype !== 4" class="successTips" :src="require('@/common/images/toolmgt/pay_01.png')" alt="">
                                <img v-if="ruleForm.resulttype === 3" class="redeemCodeTips" :src="require('@/common/images/toolmgt/pay_02.png')" alt="">
                                <img v-if="ruleForm.resulttype === 4" class="destroyTips" :src="require('@/common/images/toolmgt/pay_03.png')" alt="">
                                <img v-if="ruleForm.resulttype === 4" class="codeTips" :src="require('@/common/images/toolmgt/pay_04.png')" alt="">
                                <div class="selfContent" v-html="ruleForm.customcontent ? ruleForm.customcontent : '凭证说明'">此区域可进行自定义，用户在配置参数时，采用后台自带的富文本编辑器进行编辑支付后的凭证内容。</div>
                            </div>
                        </div>
                        <div class="btn" v-if="ruleForm.resulttype === 2">
                            <div class="imgBox">
                                <img :src="require('@/common/images/toolmgt/home.png')" alt="">
                                <!-- <p>回到首页</p> -->
                            </div>
                            <div class="imgBox">
                                <img :src="require('@/common/images/toolmgt/service_det.png')" alt="">
                                <!-- <p>联系客服</p> -->
                            </div>
                            <div class="link">跳转链接</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="posterSetBox">
                <div class="title">
                    <p>
                        海报设置
                        <el-tooltip :content="showPoster ? '隐藏' : '展开'" placement="top">
                            <el-switch v-model="showPoster"></el-switch>
                        </el-tooltip>
                    </p>
                </div>
                <div class="contentBox" v-show="showPoster">
                    <div class="left">
                        <el-form-item label="海报图片"  :class="{'posterImg': true, 'isRequired': ruleForm.templatetype === 1}" prop="postercoveratturlid">
                            <div class="imgBoxPoster">
                                <i class="el-icon-picture" v-if="!postercoveratturlidImg"></i>
                                <img class="activityCoverImagePoster" :src="postercoveratturlidImg.furl + '?' + time" v-else-if="postercoveratturlidImg && postercoveratturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <UploadFile :uploadType="uploadVideoType" @setFile="setPosterFile" :fileRule="fileRule"></UploadFile>
                                <!-- <el-button @click.native="openPosterDialog">选择文件</el-button> -->
                                <p>建议尺寸750*1334px的JPG、PNG格式，<br> 图片小于2M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="邀请头像" prop="name">
                            <el-switch v-model="ruleForm.isdisplayheadimg"></el-switch>
                            <el-radio-group v-model="ruleForm.headimgstyle" :disabled='!ruleForm.isdisplayheadimg'>
                                <el-radio :label="1">圆形</el-radio>
                                <el-radio :label="2">方形</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="邀请昵称" prop="name" class="inviteImg">
                            <el-switch v-model="ruleForm.isdisplaynickname"></el-switch>
                            <el-color-picker v-model="ruleForm.nicknamecolor" :disabled="!ruleForm.isdisplaynickname"></el-color-picker>
                            <el-slider :min='6' :max='48' v-model="ruleForm.nicknamesize" :disabled="!ruleForm.isdisplaynickname"></el-slider>
                        </el-form-item>
                        <el-form-item label="二维码" prop="name">
                            <el-switch v-model="ruleForm.isdisplayqrcode"></el-switch>
                        </el-form-item>

                    </div>
                    <div class="right">
                        <img :src="postercoveratturlidImg.furl + '?' + time" class="posterBg" v-if="(postercoveratturlidImg && postercoveratturlidImg.furl + '?' + time)" alt="">
                        <div @mousedown="moveHeadImg" :style="{top: ruleForm.headimgposition.split(',')[1] + 'px', left: ruleForm.headimgposition.split(',')[0] + 'px'}" :class="{'headImg': true, 'side': ruleForm.headimgstyle === 2, 'circle': ruleForm.headimgstyle === 1}" v-if="ruleForm.isdisplayheadimg">
                            头像
                        </div>
                        <div @mousedown="moveNickname" :style="{color: ruleForm.nicknamecolor ? ruleForm.nicknamecolor : '#303133', fontSize: ruleForm.nicknamesize + 'px', top: ruleForm.nicknameposition.split(',')[1]+'px', left: ruleForm.nicknameposition.split(',')[0]+'px'}" class="nickname" v-if="ruleForm.isdisplaynickname">用户昵称</div>
                        <div @mousedown="moveCode" v-show="ruleForm.isdisplayqrcode" class="rightCodeBox" :style="{top: ruleForm.qrcodeposition.split(',')[1]+'px', left: ruleForm.qrcodeposition.split(',')[0]+'px'}">
                            <div class="cover"></div>
                            <img class="serviceCode" :src="require('@/common/images/toolmgt/code.png')" alt="">
                        </div>
                        <!-- <img @mousedown="moveCode" class="serviceCode" v-if="ruleForm.isdisplayqrcode && ruleForm.qrcodeatturlid" :style="{top: ruleForm.qrcodeposition.split(',')[1]+'px', left: ruleForm.qrcodeposition.split(',')[0]+'px'}" :src="ruleForm.qrcodeatturlid.furl+'?'+time" alt=""> -->
                    </div>
                </div>
            </div>
            <div class="serviceSet">
                <div class="title">
                    <p>
                        客服设置
                        <el-tooltip :content="showService ? '隐藏' : '展开'" placement="top">
                            <el-switch v-model="showService"></el-switch>
                        </el-tooltip>
                    </p>
                </div>
                <div class="contentBox" v-show="showService">
                    <div class="left">
                        <el-form-item label="客服显示类型">
                            <el-radio-group v-model="ruleForm.servicedisplaytype">
                                <el-radio :label="1">售前+售后</el-radio>
                                <el-radio :label="2">仅售后</el-radio>
                            </el-radio-group>
                            <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                                <div class="tipsP">
                                    <p>售前+售后：出现在活动详情、排行榜、支付后凭证、未支付提醒等页面中</p>
                                    <p>仅售后：出现在支付后凭证、未支付提醒等页面中</p>
                                </div>
                                <i class="el-icon-info" slot="reference"></i>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="客服二维码" class="posterImg havaImg" prop="checkCaptain">
                            <div class="imgBoxCode">
                                <i class="el-icon-picture" v-if="!qrcodeatturlidImg.furl"></i>
                                <img class="activityCoverImage" :src="qrcodeatturlidImg.furl + '?' + time" v-else-if="qrcodeatturlidImg && qrcodeatturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <div class="btnBox">
                                    <UploadFile :uploadType="uploadVideoType" @setFile="setServiceFile" :fileRule="fileRule"></UploadFile>
                                    <el-button class="eliminate" @click="eliminateServiceImg">清除</el-button>
                                </div>
                                <!-- <el-button @click.native="openCodeDialog">选择文件</el-button> -->
                                <p>建议尺寸120*120px，JPG、PNG格式，<br> 图片小于100KB</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="客服名称">
                            <el-input v-model="ruleForm.servicename" placeholder="请输入客服名称" maxlength="20" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="客服电话" class="inviteImg serviceTel" prop="checkCaptain">
                            <el-input v-model="ruleForm.servicetel"  placeholder="请输入客服电话" maxlength="20" show-word-limit></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="客服说明">
                            <el-input v-model="ruleForm.servicedesp"  placeholder="请输入客服说明" maxlength="20" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="客服按钮" class="inviteImg">
                            <el-input v-model="ruleForm.buttontext" maxlength="6" show-word-limit placeholder="展示购买后首页客服按钮名称，建议不超过6字"></el-input>
                        </el-form-item> -->
                    </div>
                </div>
            </div>
            <!-- <div class="shareSet">
                <div class="title shareTitle"><p>分享设置<el-switch v-model="showShare"></el-switch></p></div>
                <div class="contentBox" v-if="showShare">
                    <el-form-item label="分享图片" class="shareImg">
                        <div class="imgBoxCode">
                            <i class="el-icon-picture" v-if="!shareatturlImg"></i>
                            <img class="activityShareImage" :src="shareatturlImg.furl + '?' + time" v-else-if="shareatturlImg && shareatturlImg.furl + '?' + time" alt="">
                        </div>
                        <div class="uploadFileBox">
                            <UploadFile :uploadType="uploadVideoType" @setFile="_setShareImage" :fileRule="fileRule"></UploadFile>
                            <p>建议尺寸120*120px的JPG、PNG格式，<br> 图片小于100KB</p>
                        </div>
                    </el-form-item>
                    <el-form-item label="分享标题">
                        <el-input v-model="ruleForm.sharesubject" maxlength="40" show-word-limit placeholder="活动微信分享的时候展示的标题，不超过40字"></el-input>
                    </el-form-item>
                    <el-form-item label="分享内容">
                        <el-input v-model="ruleForm.sharecontent" type="textarea" maxlength="100" resize="none" show-word-limit placeholder="活动微信分享的时候展示的内容，不超过100字"></el-input>
                    </el-form-item>
                </div>
            </div> -->
            <el-form-item class="btnBox">
                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
        <!-- <ShopLocalCropper :cropperOption="codeCropperOption" ref="codeLocalCropper" @setImage="_setCodeImage" :uploadType="uploadType"></ShopLocalCropper> -->
        <!-- <ShopLocalCropper :cropperOption="posterCropperOption" :size="'2'" ref="posterLocalCropper" @setImage="_setPosterImage" :uploadType="uploadType"></ShopLocalCropper> -->
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <ShopLocalCropper :cropperOption="cropperOption" ref="disadlocalCropper" @setImage="_setDisadImage" :uploadType="uploadType"></ShopLocalCropper>
        <shopDistribution ref="shop"></shopDistribution>
    </div>
</template>
<script>
import UploadFile from 'base/upload/uploadFile2'
import UploadFile2 from 'base/upload/uploadFile3'
import UEditor from 'base/uEditor/uEditor2'
import shopDistribution from 'base/uEditor/dataComponents/shopDistribution.vue'
import {findHostMoney} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {computeFileSize} from 'common/js/tools'
import {addEditActivityV2, getActivityMsgV2} from 'api/nationalDistribution'
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import { format } from 'path'
export default {
    name: 'activityEdit',
    data() {
        let checkCaptain = (rule, value, callback) => {
            if (this.ruleForm.isopeneventheader) {
                if (this.ruleForm.servicetel || this.qrcodeatturlidImg.furl) {
                    callback()
                } else {
                    callback('请设置客服二维码或者客服电话')
                }
            } else {
                callback()
            }
        }
        let checkcoveratturlid = (rule, value, callback) => {
            if (this.ruleForm.templatetype === 1 || this.ruleForm.disadlinktype === 1) {
                if (this.coveratturlid) {
                    callback()
                } else {
                    callback('请上传活动主图')
                }
            } else {
                    callback()
            }
        }
        let checkdate = (rule, value, callback) => {
            let now = new Date().getTime()
            if (!this.ruleForm.begintime || !this.ruleForm.endtime) {
                if (!this.ruleForm.begintime) {
                    callback('请选择开始时间')
                } else if (!this.ruleForm.endtime) {
                    callback('请选择结束时间')
                }
            } else if (new Date(this.ruleForm.endtime).getTime() === new Date(this.ruleForm.begintime).getTime() || new Date(this.ruleForm.endtime).getTime() < new Date(this.ruleForm.begintime).getTime()) {
                callback('开始时间不能小于等于结束时间')
            } else {
                callback()
            }
        }
        let checkeventdesp = (rule, value, callback) => {
            if (this.ruleForm.eventdesp) {
                callback()
            } else {
                callback('请输入活动详情')
            }
        }
        // 检查分销价格
        let checksaleprice = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
            if (this.ruleForm.distype === 1) {
                if (!this.ruleForm.saleprice) {
                    callback('请输入分销价格')
                } else if (!numRegular.test(this.ruleForm.saleprice)) {
                    callback('请输入保留两位的正数')
                } else if (this.ruleForm.uprice && Number(this.ruleForm.uprice) <= Number(this.ruleForm.saleprice)) {
                    callback('分销价格需要小于划线价格')
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        let checkuprice = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
            if (this.ruleForm.distype === 1) {
                if (!this.ruleForm.uprice) {
                    callback('请输入划线价格')
                } else if (!numRegular.test(this.ruleForm.uprice)) {
                    callback('请输入保留两位的正数')
                } else if (Number(this.ruleForm.uprice) <= Number(this.ruleForm.saleprice)) {
                    callback('划线价格需要大于分销价格')
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        let checkpostercoveratturlid = (rule, value, callback) => {
            if (this.ruleForm.templatetype === 1) {
                if (this.postercoveratturlid) {
                    callback()
                } else {
                    callback('请上传海报图片')
                }
            } else {
                callback()
            }
        }
        let checkqrcodeatturlid = (rule, value, callback) => {
            if (this.ruleForm.qrcodeatturlid) {
                callback()
            } else {
                // callback('请上传客服二维码')
                callback()
            }
        }
        let checkresulttype = (rule, value, callback) => {
            // if (this.ruleForm.resulttype === 1) {
            //     if (this.ruleForm.customcontent) {
            //         callback()
            //     } else {
            //         callback('请输入自定义内容')
            //     }
            // } else
            if (this.ruleForm.resulttype === 2) {
                let regular = /(http|https):\/\/([\w.]+\/?)\S*/
                if (!this.ruleForm.linkurl) {
                    callback('请输入跳转链接')
                } else if (!regular.test(this.ruleForm.linkurl)) {
                    callback('请输入以http或https开头的跳转链接')
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        let checkdislayer = (rule, value, callback) => {
            if (value >= 1 && value <= 2) {
                callback()
            } else {
                callback('分销层级只能是1级或者2级')
            }
        }
        let checkfirstbrokerage = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
            if (this.ruleForm.distype === 1) {
                if (numRegular.test(this.ruleForm.firstbrokerage)) {
                    if (this.ruleForm.dislayer === 1) {
                        if (this.ruleForm.dispricetype === 1) {
                            if (Number(value) > Number(this.ruleForm.saleprice)) {
                                callback('收益要小于分销价格')
                            } else {
                                callback()
                            }
                        } else {
                            if (Number(value) > 100) {
                                callback('收益不能大于分销价格的100%')
                            } else {
                                callback()
                            }
                        }
                    } else {
                        if (this.ruleForm.dispricetype === 1) {
                            if (!this.ruleForm.secondbrokerage) {
                                if (Number(value) > Number(this.ruleForm.saleprice)) {
                                    callback('收益要小于分销价格')
                                } else {
                                    callback()
                                }
                            } else {
                                if (Number(value) + Number(this.ruleForm.secondbrokerage) > Number(this.ruleForm.saleprice)) {
                                    callback('收益要小于分销价格')
                                } else {
                                    callback()
                                }
                            }
                        } else {
                            if (!this.ruleForm.secondbrokerage) {
                                if (Number(value) > 100) {
                                    callback('收益不能大于分销价格的100%')
                                } else {
                                    callback()
                                }
                            } else {
                                if (Number(value) + Number(this.ruleForm.secondbrokerage) > 100) {
                                    callback('收益不能大于分销价格的100%')
                                } else {
                                    callback()
                                }
                            }
                        }
                    }
                } else {
                    callback('直接收益请输入保留两位小数的正数')
                }
            } else {
                callback()
            }

        }
        let checksecondbrokerage = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
            if (this.ruleForm.distype === 1) {
                if (this.ruleForm.dislayer === 2) {
                    if (this.ruleForm.secondbrokerage) {
                        if (numRegular.test(value)) {
                            if (this.ruleForm.dispricetype === 1) {
                                if (this.ruleForm.firstbrokerage) {
                                    if (Number(value) + Number(this.ruleForm.firstbrokerage) > Number(this.ruleForm.saleprice)) {
                                        callback('收益要小于分销价格')
                                    } else {
                                        callback()
                                    }
                                } else {
                                    if (Number(value) > Number(this.ruleForm.saleprice)) {
                                        callback('收益要小于分销价格')
                                    } else {
                                        callback()
                                    }
                                }
                            } else {
                                if (this.ruleForm.firstbrokerage) {
                                    if (Number(value) + Number(this.ruleForm.firstbrokerage) > 100) {
                                        callback('收益不能大于分销价格的100%')
                                    } else {
                                        callback()
                                    }
                                } else {
                                    if (Number(value) > 100) {
                                        callback('收益不能大于分销价格的100%')
                                    } else {
                                        callback()
                                    }
                                }
                            }
                        } else {
                            callback('间接收益请输入保留两位小数的正数')
                        }
                    } else {
                        callback('请输入间接收益')
                    }
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        let checkdisadAffix = (rule, value, callback) => {
            if (this.disadcontentid) {
                callback()
            } else {
                if (this.ruleForm.disadcontenttype === 1) {
                    callback('请选择广告图片')
                } else if (this.ruleForm.disadcontenttype === 2) {
                    callback('请选择广告视频')
                }
            }
        }
        let checkdisadLink = (rule, value, callback) => {
            if (this.ruleForm.disadlinktype === 3) {
                if (!this.ruleForm.disadcustomurl) {
                    callback('请输入自定义链接')
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        let checkdisadcontentid = (rule, value, callback) => {
            if (this.ruleForm.templatetype === 2) {
                if (!this.disadcontentid) {
                    callback('请上传贴片附件')
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        let checkeventheaderbrokerage = (rule, value, callback) => {
            if (this.ruleForm.isopeneventheader && this.ruleForm.dislayer === 1) {
                if (this.ruleForm.eventheaderbrokerage !== '') {
                    callback()
                } else {
                    callback('请输入队长收益')
                }
            } else {
                callback()
            }
        }
        return {
            showDistributionForm: false, // 分销表单展开收起
            showPayVouchers: true, // 支付凭证展开收起
            showPoster: true, // 分销海报展开收起
            showService: false, // 客服设置展开收起
            pageshow: false,
            // showShare: false, // 分享设置展开收起
            coveratturlid: {
                furl: 'http://img.jingketong.cn/shop/dis/dis_default_cover.png',
                key: 'http://img.jingketong.cn/shop/dis/dis_default_cover.png',
                vsource: 1
            }, // 活动主图
            coveratturlidImg: {
                furl: 'http://img.jingketong.cn/shop/dis/dis_default_cover.png',
                key: 'http://img.jingketong.cn/shop/dis/dis_default_cover.png',
                vsource: 1
            },
            qrcodeatturlid: {
                furl: 'http://img.jingketong.cn/shop/dis/dis_default_servicecode.jpg',
                key: 'http://img.jingketong.cn/shop/dis/dis_default_servicecode.jpg',
                vsource: 1
            }, // 客服二维码图片
            qrcodeatturlidImg: {
                furl: 'http://img.jingketong.cn/shop/dis/dis_default_servicecode.jpg',
                key: 'http://img.jingketong.cn/shop/dis/dis_default_servicecode.jpg',
                vsource: 1
            },
            postercoveratturlid: {
                furl: 'http://img.jingketong.cn/shop/dis/dis_default_poster.png',
                key: 'http://img.jingketong.cn/shop/dis/dis_default_poster.png',
                vsource: 1
            }, // 海报图片
            postercoveratturlidImg: {
                furl: 'http://img.jingketong.cn/shop/dis/dis_default_poster.png',
                key: 'http://img.jingketong.cn/shop/dis/dis_default_poster.png',
                vsource: 1
            },
            shareatturl: '', // 分享图片
            shareatturlImg: '',
            disadcontentid: '', // 贴片附件
            disadcontentidurl: '',
            disabled: false,
            isBegin: false,
            time: new Date().getTime(),
            formData: new FormData(),
            formData2: new FormData(),
            balance: '', // 余额
            ruleForm: {
                date: '',
                innerid: '', // 活动innerid
                posterinnerid: '', // 海报信息ID
                eventsource: 1, // 活动来源
                kmctype: '', // 内容类型
                kmcinnerid: '', // 内容innerid
                title: '【演示活动】一键保存即可发起活动~', // 活动标题
                subtitle: '活动简介里要强调本次活动的亮点或者客户权益，以关键词的形式展示，吸引用户点击', // 活动副标题
                fakesalecount: '', // 虚拟已售数量
                coveratturlid: '', // 活动Logo图 json串
                coveratturlidImg: '',
                begintime: '', // 活动开始时间
                endtime: '', // 活动结束时间
                uprice: '99.00', // 划线价格
                saleprice: '1.00', // 销售活动
                maxbuycount: '1', // 最大购买次数
                eventdesp: '<p><img src="http://img.jingketong.cn/shop/dis/dis_default_content_01.png" /></p><p><img src="http://img.jingketong.cn/shop/dis/dis_default_content_02.jpg" /></p>', // 活动详情
                isdisplayrank: false, // 是否显示排行榜——0否 1是
                dislayer: 2, // 分销列表层级
                joindiscond: 1, // 分销条件——1无条件 2购买后分销
                cashtype: 1, // 佣金提现方式——1微信零钱 2分销账户
                dispricetype: 1, // 分销价格类型——0未设置 1固定收益 2比例收益
                firstbrokerage: '0.55', // 一级收益
                secondbrokerage: '0.35', // 二级收益
                bindclienttype: 2, // 分销绑定类型——1支付绑定 2邀请绑定
                resulttype: 1, // 支付凭证类型——1自定义 2跳转链接 3兑换码 4核销码
                linkurl: '', // 支付链接地址
                customcontent: '', // 支付自定义内容
                code: '', // 兑换码——用逗号分隔
                qrcodeatturlid: '', // 客服二维码图(JSON串)
                qrcodeatturlidImg: '',
                servicedesp: '', // 客服说明
                buttontext: '', // 客服按钮
                postercoveratturlid	: '', // 海报LOGO图(JSON串)
                postercoveratturlidImg: '',
                isdisplayheadimg: true, // 是否显示头像
                headimgstyle: 1, // 头像样式——1圆形 2方形
                headimgposition: '22,22', // 头像位置——格式X,Y
                isdisplaynickname: true, // 是否显示昵称
                nicknamecolor: '#000000', // 昵称字体颜色，带#
                nicknamesize: 10, // 昵称字体大小
                nicknameposition: '72,32', // 昵称位置——格式X,Y
                isdisplayqrcode: true, // 是否显示二维码
                qrcodeposition: '190,420', // 二维码位置——格式X,Y,
                // shareatturl: '', // 分享设置图（JSON串）
                // shareatturlImg: '',
                // sharesubject: '',
                // sharecontent: '',
                templatetype: 1, // 模板类型 1活动模板  2文章模板
                distype: 1, // 分销类型 1支付分销 2表单分销 3阅读分销
                articledesp: '', // 文章详情
                articletitle: '', // 文章标题
                disadlinktype: 1, // 贴片广告链接类型——1链接活动详情 2链接参与活动 3自定义链接
                disadname: '', // 贴片名称
                disadcontent: '', // 贴片内容
                disadcontenttype: 1, // 贴片广告内容类型——1图片 2视频
                disadcontentid: '', // 贴片附件(JSON串)
                disadcontentidurl: '',
                disadcustomurl: '',
                maxdisordercount: '', // 分销订单数量
                maxdisstockcount: '', // 分销库存
                isopeneventheader: false, // 是否开启团长
                eventheaderbrokeragetype: 1, // 团长收益类型——1固定收益 2比例收益
                eventheaderbrokerage: '', // 团长收益值
                eventheaderexpiredays: 0, // 团长有效期 0为活动结束时间
                customformdataList: [],
                customformdata: '', // 	表单信息 多个项目以|分隔，各个项目要素之间用英文分号分隔，要素之间格式为 表单id;表单类型;项目名称;是否必填;选项表，选项表用英文逗号分隔
                eventheaderbegintime: '', // 团长开始时间
                eventheaderendtime: '', // 团长结束时间
                servicedisplaytype: 1, // 客服显示类型——1售前+售后 2仅售后
                servicename: '自定义添加客服的提示语', // 客服名称
                servicetel: '17722476069', // 客服电话
            },
            rules: {
                eventheaderbrokerage: [
                    {validator: checkeventheaderbrokerage, trigger: 'blur'}
                ],
                coveratturlid: [
                    {validator: checkcoveratturlid, trigger: 'blur'}
                ],
                title: [
                    {required: true, message: '活动标题最小字数为1', trigger: 'blur'},
                    {max: '40', message: '不超过40字',  trigger: 'blur'}
                ],
                articletitle: [
                    {required: true, message: '请输入文章标题', trigger: 'blur'},
                    {max: '40', message: '不超过40字',  trigger: 'blur'}
                ],
                subtitle: [
                    {max: '100', message: '不超过100字', trigger: 'blur'}
                ],
                date: [
                    {validator: checkdate, trigger: 'blur'}
                ],
                saleprice: [
                    {validator: checksaleprice, trigger: 'blur'}
                ],
                uprice: [
                    {validator: checkuprice, trigger: 'blur'}
                ],
                dislayer: [
                    {required: true, message: '请选择分销层级', trigger: 'blur'},
                    {validator: checkdislayer, tirgger: 'blur'}
                ],
                joindiscond: [
                    {required: true, message: '请选择分销条件', trigger: 'blur'}
                ],
                cashtype: [
                    {required: true, message: '请选择佣金提现方式', trigger: 'blur'}
                ],
                dispricetype: [
                    {required: true, message: '请选择分销类型', trigger: 'blur'}
                ],
                firstbrokerage: [
                    {required: true, message: '请输入一级分销收益', trigger: 'blur'},
                    {validator: checkfirstbrokerage, trigger: 'blur'}
                ],
                secondbrokerage: [
                    {validator: checksecondbrokerage, trigger: 'blur'}
                ],
                bindclienttype: [
                    {required: true, message: '请选择分销绑定方式', trigger: 'blur'}
                ],
                postercoveratturlid: [
                    {validator: checkpostercoveratturlid, trigger: 'blur'}
                ],
                qrcodeatturlid: [
                    {validator: checkqrcodeatturlid, trigger: 'blur'}
                ],
                servicedesp: [
                    {required: true, message: '请输入客服说明', trigger: 'blur'},
                    {max: 20, message: '20字以内', trigger: 'blur'}
                ],
                buttontext: [
                    {required: true, message: '请输入客服按钮名称', trigger: 'blur'},
                    {max: 6, message: '6字以内', trigger: 'blur'}
                ],
                resulttype: [
                    {validator: checkresulttype, trigger: 'change'}
                ],
                disadname: [
                    // {required: true, message: '请输入贴片名称', trigger: 'blur'},
                    {max: '40', message: '不超过20字',  trigger: 'blur'}
                ],
                disadcontent: [
                    // {required: true, message: '请输入贴片内容', trigger: 'blur'},
                    {max: '50', message: '不超过50字',  trigger: 'blur'}
                ],
                disadAffix: [
                    {validator: checkdisadAffix, trigger: 'blur'}
                ],
                disadLink: [
                    {validator: checkdisadLink, trigger: 'blur'}
                ],
                disadcontentid: [
                    {validator: checkdisadcontentid, trigger: 'blur'}
                ],
                checkCaptain: [
                    {validator: checkCaptain, trigger: 'blur'}
                ]
            },
            begintime: '',
            publicPath: process.env.BASE_URL,
            uploadVideoType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [750, 420], // 截图框的宽高比例
                enlarge: 750 / 420, // 图片根据截图框输出比例倍数
                autoCropWidth: 225, // 默认生成截图框宽度
                autoCropHeight: 126 // 默认生成截图框高度
            },
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: '.jpg,.jpeg,.png',
                size: 2,
                width: '750',
                height: '420'
            },
            videoRule: {
                btnName: '选择文件',
                cls: '',
                accept: '.mp4',
                size: 10,
                width: '',
                height: ''
            },
            xlsRule: {
                btnName: '点击上传',
                cls: '',
                accept: '.xls,.xlsx',
                size: 10,
                width: '',
                height: ''
            },
            showMore: true,
            nowDate: ''
        }
    },
    created() {
    },
    mounted() {
        this.findHostMoney()
        if (this.$route.query.id) {
            if (!this.$route.query.iscopy) {
                this.disabled = true
            }
            this.getActivityMsg()
        } else {
            this.pageshow = true
            let date =  new Date()
            this.nowDate = this.formattingTime(date)
            // let p = '<p>①可以引导客户添加客服微信，在此处上传客服二维码；</p><p>②可以引导客户关注公众号，在此处上传公众号二维码；</p><p>③可以告知客户活动相关的活动提示，比如活动地点、活动时间、联系方式、使用说明、注意事项、兑换方式等。</p>'
            let p = '<p><img src="http://img.jingketong.cn/shop/dis/dis_default_content_01.png" /></p><p><img src="http://img.jingketong.cn/shop/dis/dis_default_content_02.jpg" /></p>'
            this.$refs.uEditor1.init(p)
            // this.ruleForm.customcontent = p
            let sevenDate = new Date().getTime()
            sevenDate = sevenDate + 86400000 * 7
            sevenDate = new Date(sevenDate)
            this.ruleForm.begintime = this.formattingTime(date)
            this.ruleForm.endtime = this.formattingTime(sevenDate)
            // console.log(, this.formattingTime(sevenDate))
        }
    },
    methods: {
        // 清除客服图片
        eliminateServiceImg() {
            this.qrcodeatturlidImg.furl = ''
            this.qrcodeatturlidImg.key = ''
            this.qrcodeatturlid.key = ''
            this.qrcodeatturlid.furl = ''
            this.ruleForm.qrcodeatturlid = ''
        },
        // 当开启队长被禁用时  点击开启的提示
        clickSwitch() {
            console.log(222)
            if (this.ruleForm.dislayer == 2) {
                this.$message('开启活动队长模式，请把分销层级设置为1')
            }
        },
        // 去充值
        goRecharge() {
            this.$router.push({name: 'Balance'})
        },
        findHostMoney() {
            this.setLoading(true)
            findHostMoney({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.balance = data.data.allbalance
                    console.log(data)
                },
                error: data => {

                }
            })
        },
        // 格式化时间
        formattingTime(d) {
            let date = new Date(d)
            var YY = date.getFullYear() + '-'
            var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
            var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return YY + MM + DD +" "+hh + mm + ss
        },
        // 增加填写项
        addInput() {
            let obj = {
                colinnerid: '',
                coltype: 1,
                colname: '',
                isnotnull: 1,
                optionsinfo: ''
            }
            this.ruleForm.customformdataList.push(obj)
            console.log(this.ruleForm.customformdataList)
        },
        // 增加单选项
        addRandio() {
            let obj = {
                colinnerid: '',
                coltype: 6,
                colname: '',
                isnotnull: 1,
                optionsinfo: '',
                optionsArray: []
            }
            this.ruleForm.customformdataList.push(obj)
            console.log(this.ruleForm.customformdataList)
        },
        // 增加多选项
        addCheckbox() {
            let obj = {
                colinnerid: '',
                coltype: 7,
                colname: '',
                isnotnull: 1,
                optionsinfo: '',
                optionsArray: []
            }
            this.ruleForm.customformdataList.push(obj)
            console.log(this.ruleForm.customformdataList)
        },
        // 增加菜单项
        addSelect() {
            let obj = {
                colinnerid: '',
                coltype: 8,
                colname: '',
                isnotnull: 1,
                optionsinfo: '',
                optionsArray: []
            }
            this.ruleForm.customformdataList.push(obj)
            console.log(this.ruleForm.customformdataList)
        },
        // 增加新选项
        addOptions(index) {
            this.ruleForm.customformdataList[index].optionsArray.push({optionsName: ''})
            console.log(this.ruleForm.customformdataList[index].optionsArray)
        },
        // 删除表单项目
        deleteOptions(index) {
            this.ruleForm.customformdataList.splice(index, 1)
            console.log(this.ruleForm.customformdataList)
        },
        // 移除选项
        deleteOptionsName(index) {
            console.log(index)
            this.ruleForm.customformdataList[index].optionsArray.pop()
            console.log(this.ruleForm)
        },
        // 活动模板改变
        templatetypeChange(e) {
            if (e === 1) {
                this.ruleForm.distype = 1
            }
        },
        // 贴片类型改变
        disadcontenttypeChange() {
            this.disadcontentid = ''
        },
        // 分销类型改变
        distypeChange (e) {
            if (e === 3) {
                this.ruleForm.bindclienttype = 2
                this.ruleForm.disadlinktype = 3
            }


            if (e === 2) {
                this.ruleForm.disadlinktype = 2
                this.showDistributionForm = true
            } else if (e === 3) {
                this.ruleForm.disadlinktype = 3
            }


            if (e === 2 || e === 3) {
                this.ruleForm.uprice = 0
                this.ruleForm.saleprice = 0
                this.ruleForm.dispricetype = 1
                this.ruleForm.eventheaderbrokeragetype = 1
            } else {
                this.ruleForm.uprice = ''
                this.ruleForm.saleprice = ''
                this.ruleForm.disadlinktype = 1
            }
        },
        // 显示更多分销设置和收起更多分销设置
        showMoreReturn () {
            this.showMore = !this.showMore
        },
        changeData() {
            this.$refs.ruleForm.validateField(['firstbrokerage', 'secondbrokerage'])
        },
        openCodeDialog() {
            this.$refs.codeLocalCropper.openDialog()
        },
        openPosterDialog() {
            this.$refs.posterLocalCropper.openDialog()
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        openDisadDialog() {
            this.$refs.disadlocalCropper.openDialog()
        },
        _setCodeImage(file) {
            this.time = new Date().getTime()
            this.qrcodeatturlid = file
            this.qrcodeatturlidImg = file
        },
        _setShareImage(file) {
            this.time = new Date().getTime()
            this.shareatturl = file
            this.shareatturlImg = file
        },
        _setPosterImage(file) {
            this.time = new Date().getTime()
            this.postercoveratturlid = file
            this.postercoveratturlidImg = file
        },
        _setImage(file) {
            this.time = new Date().getTime()
            this.coveratturlid = file
            this.coveratturlidImg = file
        },
        _setDisadImage (file) {
            this.time = new Date().getTime()
            this.disadcontentid = file
            this.disadcontentidurl = file.furl
            // this.ruleForm.coveratturlidImg = file
        },
        handleDownTemplate() {
            var link = document.createElement('a')
            // link.href = `${this.publicPath}template/code.xls`
            link.href = `http://img.jingketong.cn/download/dis_eccode_template.xlsx`
            link.download = 'code.xls'
            link.click() // 释放内存
            window.URL.revokeObjectURL(link.href)
        },
        choiceShop() {
            // this.$refs.shop.openDialog()
        },
        handleImport(file) {
            if (!this.$route.query.id) {
                const fileInfo = file.raw
                this.formData2.append('importexcel', fileInfo)
            } else {
                this.$message.error('编辑时不能修改兑换码')
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid, name) => {
                if (valid) {
                    let coveratturlid = ''
                    if (!this.ruleForm.innerid || this.$route.query.iscopy) {
                        delete this.ruleForm.innerid
                    }
                    if (this.coveratturlid.furl) {
                        delete this.coveratturlid.type
                        this.ruleForm.coveratturlid = JSON.stringify(this.coveratturlid)
                    }
                    if (!this.ruleForm.maxbuycount) {
                        this.ruleForm.maxbuycount = 1
                    }
                    if (!this.ruleForm.fakesalecount) {
                        this.ruleForm.fakesalecount = 0
                    }
                    if (this.ruleForm.maxdisordercount === '') {
                        this.ruleForm.maxdisordercount = 0
                    }
                    if (this.ruleForm.maxdisstockcount === '') {
                        this.ruleForm.maxdisstockcount = 0
                    }
                    if (this.ruleForm.isdisplayrank) {
                        this.ruleForm.isdisplayrank = 1
                    } else {
                        this.ruleForm.isdisplayrank = 0
                    }
                    let qrcodeatturlid = ''
                    if (this.qrcodeatturlid.furl) {
                        delete this.qrcodeatturlid.type
                        this.ruleForm.qrcodeatturlid = JSON.stringify(this.qrcodeatturlid)
                    }
                    console.log(this.ruleForm.qrcodeatturlid)
                    let postercoveratturlid = ''
                    if (this.postercoveratturlid.furl) {
                        delete this.postercoveratturlid.type
                        this.ruleForm.postercoveratturlid = JSON.stringify(this.postercoveratturlid)
                    }
                    // if(this.shareatturl) {
                    //     if (this.shareatturl.furl) {
                    //         delete this.shareatturl.type
                    //         this.ruleForm.shareatturl = JSON.stringify(this.shareatturl)
                    //     }
                    // }
                    if (this.ruleForm.isopeneventheader) {
                        this.ruleForm.isopeneventheader = 1
                    } else {
                        this.ruleForm.isopeneventheader = 0
                        this.ruleForm.eventheaderbrokerage = 0
                    }
                    if (this.ruleForm.isdisplayheadimg) {
                        this.ruleForm.isdisplayheadimg = 1
                    } else {
                        this.ruleForm.isdisplayheadimg = 0
                    }
                    if (this.ruleForm.isdisplaynickname) {
                        this.ruleForm.isdisplaynickname = 1
                    } else {
                        this.ruleForm.isdisplaynickname = 0
                    }
                    if (this.ruleForm.isdisplayqrcode) {
                        this.ruleForm.isdisplayqrcode = 1
                    } else {
                        this.ruleForm.isdisplayqrcode = 0
                    }
                    if (!this.ruleForm.kmctype) {
                        this.ruleForm.kmctype = ''
                    }
                    if (this.ruleForm.templatetype === 2) {
                        delete this.disadcontentid.type
                        this.ruleForm.disadcontentid = JSON.stringify(this.disadcontentid)
                    }
                    if (this.ruleForm.distype === 2 && !this.ruleForm.customformdataList.length) {
                        this.replaceValue()
                        this.$message.error('表单分销至少需要设置一个表单项目')
                        return
                    }
                    if (this.ruleForm.distype === 3) {
                        this.ruleForm.customformdataList = []
                    }
                    if (this.ruleForm.customformdataList.length) {
                        let form = true
                        this.ruleForm.customformdataList.some((obj, index) => {
                            if (obj.coltype === 1) {
                                if (!obj.colname) {
                                    this.replaceValue()
                                    this.$message.error('请完善您的表单数据！')
                                    form = false
                                    return true
                                }
                            } else {
                                obj.optionsArray.some((item, i) => {
                                    if (!item.optionsName) {
                                        this.replaceValue()
                                        this.$message.error('请完善您的表单数据！')
                                        form = false
                                        return true
                                    }
                                })
                            }
                        })
                        if (form) {
                            this.ruleForm.customformdataList.some((obj, index) => {
                                if (obj.coltype !== 1) {
                                    let optionArr=[]
                                    obj.optionsArray.some((item, i) => {
                                        optionArr.push(item.optionsName)
                                        // obj.arr.some((item, i) => {
                                        // })
                                    })
                                    obj.optionsinfo = optionArr.join(',')
                                }
                            })
                            if (this.$route.query.iscopy == '1') {
                                this.ruleForm.customformdataList.forEach(obj => {
                                    obj.colinnerid = ''
                                })
                            }
                            this.ruleForm.customformdata = JSON.stringify(this.ruleForm.customformdataList)
                        } else {
                            this.replaceValue()
                            this.$message.error('请完善您的表单数据！')
                            return
                        }
                    }
                    if (this.$route.query.iscopy === '1') {
                        this.ruleFrom.innerid = ''
                    }
                    if (this.ruleForm.dislayer === 1) {
                        this.ruleForm.secondbrokerage = 0
                    }
                    this.formData = new FormData()
                    for(let key in this.ruleForm) {
                        this.formData.append(key, this.ruleForm[key])
                    }
                    console.log(this.ruleForm)
                    if (this.$route.query.id || this.ruleForm.resulttype!=3) {
                        var content = '<a id="a"><b id="b">hey!</b></a>';
                        var blob = new Blob([content], { type: "text/xml"});
                        this.formData.append('importexcel', blob)
                    } else {
                        if(!this.formData2.get('importexcel')){
                            this.replaceValue()
                            this.$message.error('请选择兑换码文件！')
                            return
                        }
                        this.formData.append('importexcel', this.formData2.get('importexcel'))
                    }
                    this.setLoading(true)
                    addEditActivityV2({
                        data: this.formData,
                        success: data => {
                            this.setLoading(false)
                            this.$message.success('操作成功')
                            if (this.$route.query.id && !this.$route.query.iscopy) {
                                this.$router.push({name: 'NDActivityList', query: {refresh: '0'}})
                            } else {
                                this.$router.push({name: 'NDActivityList', query: {refresh: '1'}})
                            }
                        },
                        error: data => {
                            this.setLoading(false)
                            if (data.msg === '兑换码文件内容错误') {
                                this.replaceValue()
                                this.formData = new FormData()
                            }
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    this.replaceValue()
                    console.log(this.ruleForm)
                    for(let key  in name){
                        this.$message.error(name[key][0].message)
                        return false
                    }
                    // this.$message.error('请完善您的数据！')
                    return false
                }
            })
        },
        // 重新赋值
        replaceValue() {
            if (this.ruleForm.isdisplayheadimg === 0) {
                this.ruleForm.isdisplayheadimg = false
            } else {
                this.ruleForm.isdisplayheadimg = true
            }
            if (this.ruleForm.isdisplaynickname === 0) {
                this.ruleForm.isdisplaynickname = false
            } else {
                this.ruleForm.isdisplaynickname = true
            }
            if (this.ruleForm.isdisplayqrcode === 0) {
                this.ruleForm.isdisplayqrcode = false
            } else {
                this.ruleForm.isdisplayqrcode = true
            }
            if (this.ruleForm.isopeneventheader === 0) {
                this.ruleForm.isopeneventheader = false
            } else if (this.ruleForm.isopeneventheader === 1) {
                this.ruleForm.isopeneventheader = true
            }
        },
        cancel() {
            this.$router.push({name: 'NDActivityList'})
        },
        // 试看内容
        getTrySeeContent(content) {
            this.ruleForm.eventdesp = content
        },
        // 文章详情
        getArticleTrySeeContent(content) {
            console.log(content)
            this.ruleForm.articledesp = content
        },
        // 自定义内容
        getSelfContent(content) {
            this.ruleForm.customcontent = content
        },
        // setFile(file) {
        //     computeFileSize()
        //     this.ruleForm.coveratturlid = file
        //     this.time = new Date().getTime()
        // },
        setDisadFile(file) {
            computeFileSize()
            this.disadcontentid = file
            this.disadcontentidurl = file.furl
            this.time = new Date().getTime()
        },
        setServiceFile(file) {
            computeFileSize()
            this.qrcodeatturlid = file
            this.qrcodeatturlidImg = file
            this.time = new Date().getTime()
        },
        setPosterFile(file) {
            computeFileSize()
            this.postercoveratturlid = file
            this.postercoveratturlidImg = file
            this.time = new Date().getTime()
        },
        // 移动头像
        moveHeadImg(e) {
            let odiv = e.target       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 250) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.headimgposition = left + ',' + this.ruleForm.headimgposition.split(',')[1]
                }
                if (top >= 0 && top < 495) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.headimgposition = this.ruleForm.headimgposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 移动昵称
        moveNickname(e) {
            let odiv = e.target       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 250) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.nicknameposition = left + ',' + this.ruleForm.nicknameposition.split(',')[1]
                }
                if (top >= 0 && top < 520) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.nicknameposition = this.ruleForm.nicknameposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 移动二维码
        moveCode(e) {
            let odiv = e.target.parentElement       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 235) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.qrcodeposition = left + ',' + this.ruleForm.qrcodeposition.split(',')[1]
                }
                if (top >= 0 && top < 470) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.qrcodeposition = this.ruleForm.qrcodeposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 获取活动详情
        getActivityMsg() {
            this.setLoading(true)
            getActivityMsgV2({
                data: {innerid: this.$route.query.id},
                success: data => {
                    this.setLoading(false)
                    data.data.date = [data.data.begintime, data.data.endtime]
                    if (data.data.isdisplayrank) {
                        data.data.isdisplayrank = true
                    } else {
                        data.data.isdisplayrank = false
                    }
                    if (data.data.isdisplayheadimg) {
                        data.data.isdisplayheadimg = true
                    } else {
                        data.data.isdisplayheadimg = false
                    }
                    if (data.data.isdisplaynickname) {
                        data.data.isdisplaynickname = true
                    } else {
                        data.data.isdisplaynickname = false
                    }
                    if (data.data.isdisplayqrcode) {
                        data.data.isdisplayqrcode = true
                    } else {
                        data.data.isdisplayqrcode = false
                    }
                    if (data.data.isopeneventheader) {
                        data.data.isopeneventheader = true
                    } else {
                        data.data.isopeneventheader = false
                    }
                    // this.begintime = data.data.begintime
                    if (new Date(data.data.begintime).getTime() <= new Date().getTime()) {
                        if (!this.$route.query.iscopy) {
                            this.isBegin = true
                        }
                    }
                    data.data.nicknamesize = Number(data.data.nicknamesize)
                    data.data.customformdataList = []
                    if (data.data.formlist) {
                        data.data.customformdataList = JSON.parse(JSON.stringify(data.data.formlist))
                        data.data.customformdataList.some((obj, index) => {
                            if (obj.coltype !== 1) {
                                let optionsArr = obj.optionsinfo.split(',')
                                obj.optionsArray = []
                                optionsArr.some((item, i) => {
                                    obj.optionsArray.push({optionsName: item})
                                })
                            }
                        })
                    }
                    this.ruleForm = data.data
                    this.coveratturlidImg = this.ruleForm.coveratturlid
                    this.coveratturlid = this.ruleForm.coveratturlid
                    this.postercoveratturlidImg = this.ruleForm.postercoveratturlid
                    this.postercoveratturlid = this.ruleForm.postercoveratturlid
                    this.qrcodeatturlidImg = this.ruleForm.qrcodeatturlid
                    this.qrcodeatturlid = this.ruleForm.qrcodeatturlid
                    // this.shareatturlImg = this.ruleForm.shareatturl
                    this.disadcontentidurl = this.ruleForm.disadcontentid.furl
                    this.disadcontentid = this.ruleForm.disadcontentid
                    if (!this.ruleForm.headimgposition) {
                        this.ruleForm.headimgposition = '22,22'
                    }
                    if (!this.ruleForm.nicknamecolor) {
                        this.ruleForm.nicknamecolor = '#000000'
                    }
                    if (!this.ruleForm.nicknamesize) {
                        this.ruleForm.nicknamesize = 10
                    }
                    if (!this.ruleForm.nicknameposition) {
                        this.ruleForm.nicknameposition = '98,38'
                    }
                    if (!this.ruleForm.qrcodeposition) {
                        this.ruleForm.qrcodeposition = '190,420'
                    }
                    if (this.ruleForm.maxdisordercount) {
                        this.showMore = false
                    }
                    if (this.ruleForm.maxdisstockcount) {
                        this.showMore = false
                    }
                    if (this.ruleForm.fakesalecount) {
                        this.showMore = false
                    }
                    if (this.ruleForm.isopeneventheader) {
                        this.showMore = false
                    }
                    if (this.ruleForm.customformdataList.length) {
                        this.showDistributionForm = true
                    }
                    if (this.ruleForm.postercoveratturlid) {
                        this.showPoster = true
                    }
                    if (this.ruleForm.qrcodeatturlid || this.ruleForm.servicetel) {
                        this.showService = true
                    }
                    this.pageshow = true
                    // if (this.ruleForm.shareatturl || this.ruleForm.sharesubject || this.ruleForm.sharecontent) {
                    //     this.showShare = true
                    // }
                    console.log(this.ruleForm)
                    // this.$nextTick(() =>{
                        // if (this.ruleForm.resulttype !== 2) {
                            this.$refs.uEditor2.init(this.ruleForm.customcontent)
                            // console.log(222)
                        // }
                        let that = this
                        setTimeout(() => {
                            that.$refs.uEditor1.init(this.ruleForm.eventdesp)
                            that.$refs.uEditor3.init(this.ruleForm.articledesp)
                        }, 1000)

                    // })
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'ruleForm.dislayer': {
            handler(newV) {
                console.log(newV)
                if (newV == 2) {
                    this.ruleForm.isopeneventheader = false
                }
            }
        },
        'ruleForm.maxdisstockcount': {
            handler(newV, oldV) {
                if (this.$route.query.id) {
                    if (newV < oldV) {
                        this.ruleForm.dislayer = oldV
                    }
                }
            }
        },
        'ruleForm.isopeneventheader': {
            handler(newV, oldV) {
                if (newV) {
                    this.showService = true
                }
            }
        }
    },
    components: {
        UploadFile, UEditor, shopDistribution, ShopLocalCropper, UploadFile2
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
    .form {
        margin-top: 0 !important;
    }
    .activityEdit{
        background: #F5F7FA;
        min-width: 800px;
        .title{
            padding-bottom: 20px;
            border-bottom: 1px solid #DCDFE6;
            p{
                border-left: 2px solid #409EFF;
                text-indent: 8px;
                font-size: 14px;
                font-weight: bold;
            }
        }
        .shareTitle{
            border: none;
        }
        .paster {
            margin-top: 40px;
            border: none;
            padding: 0;
        }
        .el-form{
            .el-form-item {
                .el-form-item__label{
                    text-align: left;
                    font-size: 14px;
                }
            }
            .inputTips{
                color: #C0C4CC;
                margin-left: 10px;
            }
        }
        .activityMsgBox{
            .left{
                min-width: 500px;
            }
        }
        .shareSet{
            .contentBox{
                display: block !important;
                .shareImg{
                    .el-form-item__content{
                        display: flex;
                        align-items: center;
                        line-height: 40px;
                        .imgBoxCode{
                            width: 178px;
                            height: 178px;
                            background: #F5F7FA;
                            text-align: center;
                            line-height: 178px;
                            .el-icon-picture, .el-icon-video-camera-solid{
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityShareImage{
                                width: 178px;
                                height: 178px;
                            }
                        }
                        .uploadFileBox{
                            margin-left: 12px;
                            .uploadFile{
                                .el-upload{
                                    .el-button{
                                        background: #fff;
                                        border-color: #C0C4CC;
                                        span{
                                            color: #000;
                                        }
                                    }
                                }
                            }
                            p{
                                line-height: 20px;
                                color: #909399;
                            }
                        }
                    }
                }
                .el-textarea{
                    width: 400px;
                    .el-textarea__inner{
                        width: 400px;
                    }
                }
            }
        }
        .isRequired {
            .el-form-item__label::after{
                content: '*';
                color: #F56C6C;
                margin-left: 4px;
            }
        }
        .activityMsgBox, .posterSetBox, .shareSet, .serviceSet{
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;

            .contentBox{
                padding-top: 20px;
                display: flex;
                justify-content: space-between;
                max-width: 1400px;
                .left{
                    min-width: 500px;
                    .cover,.posterImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .imgBox{
                                width: 318px;
                                height: 178px;
                                background: #F5F7FA;
                                text-align: center;
                                line-height: 178px;
                                .el-icon-picture, .el-icon-video-camera-solid{
                                    color: #DCDFE6;
                                    font-size: 40px;
                                }
                                .activityCoverImage{
                                    width: 318px;
                                    height: 178px;
                                }
                            }
                            .uploadFileBox{
                                margin-left: 12px;
                                .uploadFile{
                                    .upload-demo{
                                        .el-upload {
                                            .el-button{
                                                background: #fff;
                                                color: #000;
                                                border: 1px solid #C0C4CC;
                                            }
                                        }
                                    }
                                }
                                .btnBox {
                                    display: flex;
                                    align-items: center;
                                    .eliminate {
                                        width: 54px;
                                        min-width: 54px;
                                        margin-left: 20px;
                                    }
                                }
                                p{
                                    color: #909399;
                                    font-size: 14px;
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                    .disad {
                        .el-form-item__label::after{
                            content: '*';
                            color: #F56C6C;
                            margin-left: 4px;
                        }
                    }

                    .el-form-item{
                        .el-form-item__content{
                            .el-input{
                                width: 420px;
                            }
                            .el-date-editor{
                                .el-input__icon, .el-range-separator{
                                    line-height: 25px;
                                }
                            }
                            .mostTips{
                                color: #C0C4CC;
                            }
                            .showRankingListTips{
                                color: #909399;
                                margin-left: 20px;
                                position: relative;
                                top: 2px;
                            }
                        }
                    }
                }
                .right{
                    width: 300px;
                    height: 534px;
                    background:rgba(242,246,252,1);
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                    overflow: hidden;
                    // margin-left: 150px;
                    .innerBox{
                        width: 320px;
                        height: 482px;
                        overflow-y: scroll;
                    }
                    .home {
                        display: flex;
                        align-items: center;
                        color: #FF8142;
                        font-size: 12px;
                        height: 32px;
                        background: #fff;
                        padding-left: 12px;
                        box-sizing: border-box;
                        border-bottom: 1px solid #EBEEF5;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 8px;
                        }
                    }
                    .topBox{
                        height: 52px;
                        .top{
                            width: 300px;
                            height: 52px;
                        }
                    }
                    .coverImgBox{
                        background: #DCDCDC;
                        width: 300px;
                        height: 168px;
                        .activityCoverImage{
                            width: 300px;
                            height: 168px;
                        }
                    }
                    .priceBox{
                        height: 60px;
                        background: #fff;
                        border-bottom: 1px solid #f5f5f5;
                        padding: 7px 12px;
                        box-sizing: border-box;
                        .price{
                            color: #F56C6C;
                            margin-top: 5px;
                        }
                        .outofprint{
                            color: #909399;
                            margin-top: 10px;
                        }
                    }
                    .rightTitleBox{
                        // height: 70px;
                        background: #fff;
                        padding: 7px 12px;
                        box-sizing: border-box;
                        .rightTitle{
                            margin-top: 5px;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                            font-size: 16px;
                            font-weight: bold;
                            line-height: 24px;
                        }
                        .rightSubtitle{
                            color: #909399;
                            // padding: 0 0 10px;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                            font-size: 12px;
                            font-weight: bold;
                            line-height: 16px;
                            // margin-top: 10px;
                        }
                    }
                    .nameTime {
                        display: flex;
                        font-size: 12px;
                        background: #fff;
                        align-items: center;
                        padding-left: 13px;
                        // padding-bottom: 8px;
                        .name {
                            color:#576B95;
                        }
                        .time {
                            color: #909399;
                            margin-left: 14px;
                        }
                    }
                    .detailsBox, .articleDetailsBox{
                        margin-top: 10px;
                        .detailsTitle{
                            background: #fff;
                            padding-left: 12px;
                            height: 40px;
                            line-height: 40px;
                            border-bottom: 1px solid #f5f5f5;
                        }
                        .detailsContent{
                            background: #fff;
                            padding: 12px;
                            width: 276px;
                            overflow: hidden;
                            p{
                                width: 100%;
                                line-height: 15px;
                                text-indent: 0 !important;
                            }
                            img{
                                max-width: 100% !important;
                            }
                        }
                    }
                    .articleDetailsBox {
                        margin-top: 0;
                    }
                }
                .rightView {
                    .pasterView {
                        width: 300px;
                        height: 250px;
                        padding: 12px 13px;
                        box-sizing: border-box;
                        background: #fff;
                        box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                        margin-bottom: 175px;
                        .titleText {
                            height: 30px;
                            line-height: 15px;
                            font-size: 14px;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        .imgVideo {
                            margin: 10px 0;
                            height: 153px;
                            background: #DCDCDC;
                            img, video {
                                width: 100%;
                                height: 153px;
                            }
                        }
                        .desp {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .text {
                                width: 197px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                font-size: 12px;
                            }
                            .el-button {
                                min-width: 60px;
                                height: 30px;
                                font-size: 12px;
                                min-height: 30px;
                                background: #F56C6C;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
        .atyDetails {
            .el-form-item__label::after{
                content: '*';
                color: #F56C6C;
                margin-left: 4px;
            }
        }
        .title {
            .el-switch {
                margin-left: 22px;
            }
        }
        .date{
            .el-date-editor {
                // width: 200px !important;
            }
            .el-form-item__label::after{
                content: '*';
                color: #F56C6C;
                margin-left: 4px;
            }
            .el-form-item__content{
                width: 500px;
                .to{
                    margin: 0 13px;
                }
                .el-date-editor {
                    width: 190px !important;
                    .el-input__inner{
                        padding-right: 0;
                        // width: 200px
                    }
                }
            }
        }
        .disFrom {
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;
            .title {
                .el-switch {
                    margin-left: 22px;
                }
            }
            .contentBox {
                input{
                    outline: none;
                }
                .optionsBox {
                    margin-top: 20px;

                    .flex {
                        display: flex;
                        align-items: center;
                    }
                    .tips {
                        color: #C0C4CC;
                        font-size: 14px;
                        margin-left: 18px;
                    }
                }
                .formOptions {
                    height: 60px;
                    display: flex;
                    width: 344px;
                    border: 1px solid #D8DCE6;
                    // border-radius: 4px;
                    &>div {
                        flex: 1;
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        line-height: 20px;
                        color: #606266;
                        .name {
                            margin-top: 8px;
                        }
                    }
                    img {
                        width: 20px;
                        height: 20px;
                    }
                }
                .formItem {
                    .input, .randio, .checkbox, .select {
                        position: relative;
                        width: 344px;
                        border: 1px solid #D8DCE6;
                        .optionsName {
                            input {
                                margin-left: 20px;
                            }
                        }
                        .choiceItem {
                            position: relative;
                            .delete {
                                position: absolute;
                                right: 12px;
                                bottom: 9px;
                                width: 50px;
                                height: 20px;
                                font-size: 12px;
                                text-align: center;
                                color: #606266;
                                border: 1px solid #C0C4CC;
                                line-height: 20px;
                                cursor: pointer;
                            }
                        }
                        &>div {
                            width: 344px;
                            height: 40px;
                            line-height: 40px;
                            padding: 0 10px;
                            box-sizing: border-box;
                            border-bottom: 1px solid #EEEEEE;
                        }
                        .newOptions {
                            color: #909399;
                        }
                    }
                    img {
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        top: -10px;
                        right: -10px;
                    }
                }
            }
        }

        .distributionMsgBox{
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;
            .contentBox{
                margin-top: 20px;
                .openColonel {
                    .el-switch {
                        margin-right: 15px
                    }
                    .el-icon-info {
                        margin-right: 15px;
                    }
                }
                .earnings{
                    .el-form-item__content{
                        display: flex;
                        align-items: center;
                        margin-left: 0 !important;
                        .el-radio-group {
                            line-height: 50px;
                        }
                        .balance {
                            font-size:14px;
                            margin-left: 22px;
                            color:#909399;
                            position: relative;
                            top: -5px;
                            .balanceText{
                                color:#F56C6C;
                                margin-left: 5px;
                                margin-right: 10px;
                            }
                            .el-button {
                                width: 60px;
                                height: 24px;
                                font-size: 14px;
                                min-width: 60px;
                            }
                        }
                        .one{
                            margin-bottom: 15px;
                        }
                        // .el-form-item{
                        //     .el-form-item__content{
                        //         .el-input {
                        //             margin-top: 5px;
                        //         }
                        //         .el-form-item__error{
                        //             left: 120px;
                        //         }
                        //     }
                        // }
                    }
                }
                .el-form-item{
                    .el-form-item__content{
                        .el-input{
                            width: 420px;
                        }
                        .bindclienttypeTips{
                            color: #909399;
                            line-height: 20px;
                        }
                        .el-icon-info{
                            margin-left: 5px;
                        }
                        .el-popover{

                        }
                    }
                }
                .distributionGrade{
                    .el-form-item__content{
                        .el-input-number{
                            width: 100px;
                            line-height: 32px;
                            .el-input-number__decrease,.el-input-number__increase{
                                width: 30px;
                                height: 30px;
                                border: none;
                                background: #409EFF;
                                color: #fff;
                            }
                            .el-input{
                                width: 100px;
                                .el-input__inner{
                                    padding: 0;
                                }
                            }
                        }
                    }
                }
                .showMore div {
                    margin-left: 180px;
                    width: 200px;
                    line-height: 30px;
                    text-align: center;
                    border: 1px solid #D8DCE6;
                    color: #909399;
                    font-size: 14px;
                }
                .saleprice {
                    .el-form-item__label::after {
                        content: '*';
                        color: #F56C6C;
                        font-size: 14px;
                        left: 3px;
                        position: relative;
                    }
                    .el-form-item__error {
                        top: 90%;
                    }
                }
            }
        }
        .payVoucherMsgBox{
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;
            .title {
                .el-switch {
                    margin-left: 22px;
                }
            }
            .contentBox{
                display: flex;
                justify-content: space-between;
                max-width: 1400px;
                .left{
                    // width: 970px;
                    .el-form-item__content{
                        margin-left: 10px !important;
                        .el-radio-group{
                            padding-top: 20px;
                            .noCondition, .buyDistribution, .cdkey, code {
                                height: 40px;
                                line-height: 40px;
                                .el-radio {
                                    line-height: 40px;
                                }
                            }
                            .noCondition{
                                // height: 32px;
                            }
                            .address {
                                // margin: 10px 0;
                            }
                            .cdkey{
                                // margin-top: 10px;

                                .uploadXlsBox{
                                    // display: flex;
                                    // align-items: center;
                                    .uploadXlsTips{
                                        // margin-top: 10px;
                                    }
                                }
                            }
                            .cdkey.select {
                                height: 100px;
                            }
                        }
                        .el-radio{
                            width: 90px;
                        }
                        .noCondition{
                            position: relative;
                            .tips{
                                color: #C0C4CC;
                                position: absolute;
                                top: 0px;
                                left: 140px;
                                width: 400px;
                                height: 14px;
                                display: inline-block;
                                font-size: 14px;
                            }
                        }
                        .buyDistribution{
                            // margin-top: 10px;
                            .el-input{
                                width: 420px;
                            }
                        }
                        .cdkey{
                            display: flex;
                            // margin-top: 10px;
                            // min-height: 40px;
                            .el-radio{
                                position: relative;
                                // top: 5px;
                            }
                            .uploadXlsBox{
                                .actionBox{
                                    display: flex;
                                    // align-items: center;
                                    position: relative;
                                    .uploadFile{
                                        .upload-demo{
                                            .el-upload {
                                                .el-button {
                                                    background: #67C23A;
                                                    border: 1px solid #67C23A;
                                                }
                                            }
                                        }
                                    }
                                    .download{
                                        width: 56px;
                                        height: 18px;
                                        margin-left: 34px;
                                        color: #409EFF !important;
                                        font-size: 14px;
                                        line-height: 18px;
                                        padding-top: 10px;
                                        // position: absolute;
                                        // right: 0px;
                                        // top: 0px;;
                                        cursor: pointer;
                                    }
                                }
                                .uploadXlsTips{
                                    color: #C0C4CC;
                                    font-size: 12px;
                                }
                            }
                        }
                        .code{
                            // margin-top: 10px;
                            display: flex;
                            align-items: center;
                            height: 40px;
                            .codeTips{
                                width: 400px;
                                background: #F56C6C;
                                line-height: 32px;
                                color: #fff;
                                border-radius:4px;
                                text-indent: 26px;
                                font-size: 14px;
                            }
                        }
                        .selfContent{
                            margin-top: 20px;
                            .content {
                                width: 418px;
                                line-height: 30px;
                                font-size: 14px;
                                img {
                                    max-width: 418px;
                                    height: auto;
                                }
                            }
                        }
                    }
                }
                .right{
                    margin-top: 50px;
                    width: 300px;
                    height: 534px;
                    background: #F2F6FC;
                    overflow: hidden;
                    position: relative;
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                    // margin-left: 140px;
                    .topBox{
                        width: 300px;
                        height: 52px;
                        position: relative;
                        .top{
                            width: 300px;
                            height: 52px;
                        }
                        .tips{
                            position: absolute;
                            width: 224px;
                            bottom: 10px;
                            text-align: center;
                            left: 40px;
                            font-weight: 500;
                        }
                    }
                    .tipsContentBox{
                        width: 300px;
                        height: 482px;
                        overflow: hidden;
                        .innerBox{
                            width: 320px;
                            height: 482px;
                            overflow-y: scroll;
                        }
                        .successTips{
                            width: 300px;
                            height: 104px;
                        }
                        .redeemCodeTips{
                            width: 300px;
                            height: 40px;
                        }
                        .destroyTips{
                            width: 300px;
                            height: 105px;
                        }
                        .codeTips{
                            width: 300px;
                            height: 150px;
                        }
                        .selfContent{
                            padding: 16px 12px;
                            background: #fff;
                            line-height: 20px;
                            img {
                                max-width: 100% !important;
                                height: auto;
                            }
                        }

                    }
                    .btn {
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        .imgBox {
                            width: 57px;
                            height: 40px;
                            // line-height: 40px;
                            text-align: center;
                            color: #909399;
                            font-size: 12px;
                            background: #fff;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            p {
                            }
                            img {
                                width: 16px;
                                height: 16px;
                            }
                        }
                        .link {
                            flex: 1;
                            color: #fff;
                            text-align: center;
                            line-height: 40px;
                            background: #F14040;
                            font-size: 12px;
                        }
                    }
                }
            }

        }
        .shareSet {
            .contentBox {
                .el-form-item .el-form-item__content .el-input {
                    width: 420px;
                }
                .el-textarea {
                    width: 420px;
                    .el-textarea__inner {
                        width: 420px !important;
                    }
                }
            }
        }
        .posterSetBox, .shareSet, .serviceSet{
            background: #fff;
            .contentBox{
                display: flex;
                justify-content: space-between;
                max-width: 1400px;
                .left{
                    min-width: 500px;
                    .el-form-item{
                        .el-switch{
                            margin-right: 30px;
                        }
                    }
                    .imgBoxPoster{
                        width: 178px;
                        height: 317px;
                        background: #F5F7FA;
                        text-align: center;
                        line-height: 317px;
                        .el-icon-picture{
                            color: #DCDFE6;
                            font-size: 40px;
                        }
                        .activityCoverImagePoster{
                            width: 178px;
                            height: 317px;
                        }
                    }
                    .inviteImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .el-color-picker {
                                width: 16px;
                                height: 16px;
                                margin-right: 28px;
                                .el-color-picker__trigger{
                                    padding: 0;
                                    width: 16px;
                                    height: 16px;
                                }
                            }
                            .el-slider{
                                width: 160px;
                                display: inline-block;
                            }

                        }
                    }
                    .serviceTel {
                        .el-form-item__error {
                            top: 106%;
                        }
                    }
                    // .serviceSet{
                        .title{
                            border-bottom: none;
                        }
                        .imgBoxCode{
                            width: 178px;
                            background: #F5F7FA;
                            text-align: center;
                            line-height: 178px;
                            height: 178px;
                            .el-icon-picture{
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityCoverImage{
                                width: 178px;
                                height: 178px;
                            }
                        }
                    // }
                }
                .right{
                    // margin-left: 250px;
                    position: relative;
                    .posterBg{
                        width: 300px;
                        height: 534px;
                    }
                    .headImg{
                        width: 32px;
                        height: 32px;
                        background: #D8D8D8;
                        border: 1px solid #979797;
                        text-align: center;
                        line-height: 32px;
                        position: absolute;
                        box-sizing: border-box;
                        cursor: move;
                        font-size: 12px;
                    }
                    .side{
                        border-radius: 0;
                    }
                    .circle{
                        border-radius: 50%;
                    }
                    .nickname{
                        position: absolute;
                        cursor: move;
                    }
                    .rightCodeBox{
                        cursor: move;
                        position: absolute;
                        .cover{
                            width: 64px;
                            height: 64px;
                            position: absolute;
                        }
                        img{
                            width: 64px;
                            height: 64px;
                        }
                    }
                }
            }
        }
        .el-radio__input.is-checked+.el-radio__label{
            color: #303133;
        }
        .btnBox{
            // position: fixed;
            // bottom: 40px;
            // left: 50%;
            // z-index: 1000;
            // background: #F5F7FA;
            // padding: 20px;
            .el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                background: #fff;
                height: 80px;
                line-height: 80px;
            }
        }
    }
    .el-form-item {
        // height: 30px;
        margin-bottom: 15px;
        .el-form-item__label {
            // font-weight: bold;
            color: #36383A;
        }
        .el-input {
            height: 32px;
            .el-input__inner {
                // height: 40px;
                // line-height: 40px;
            }
        }
    }
    .tipsP{
        padding: 10px;
        p{
            line-height: 20px;
        }
    }
    // .uEditor .edui-default .edui-editor
    .uEditor .edui-default .edui-editor {
        // width: 370px !important;
        max-width: 420px !important;
        height: 550px;
        .edui-editor-iframeholder {
            // width: 370px !important;
            max-width: 420px !important;
        }
    }
    .uEditor {
        .content {
            .edui-default {
                .edui-default {
                    .view {
                        .view {
                            .main_content-LcrEruCc {
                                font-size: 14px;
                                img{
                                    max-width: 387px !important;
                                    height: 100% !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .el-icon-info {
        color: #C0C4CC;
        margin-left: 16px !important;
    }
    .haveUEditor {
        .el-form-item__error {
            top: 17%;
        }
        .uEditor {
            margin-top: 7px;
        }
    }

    .havaImg {
        .el-form-item__content {
            margin-bottom: 5px;
        }
    }
    .reduceMg {
        margin-bottom: 5px;
    }
</style>
